import { Component, OnInit } from '@angular/core';
import { MainService } from 'src/app/services/main/main.service';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import * as REGEX from '../../../shared/regex';
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  environment: any = localStorage.getItem('environment') || '';
  user = this.fb.group({
    email: [localStorage.getItem('doctor_email') || this.mainService.email_value || '', [Validators.required, Validators.pattern(REGEX.Email)]],
  });
  constructor(
    public mainService: MainService,
    private router: Router,
    public fb: UntypedFormBuilder) {
  }

  ngOnInit() {
    if (localStorage.getItem('token')) {
      this.router.navigate([''])
    }
  }

  submitForm(form: any) {
    if (form.valid) {
      var data = {
        email: form.value.email.replace(/\s/g, '').toLowerCase(),
        device_type: environment.device_type,
        app_type: environment.app_type,
        app_version: environment.app_version,
        device_token: environment.device_token,
        device_id: localStorage.getItem('user')
      };
      this.mainService.api(data, 'forgot_password', true, 'object').subscribe((data: any) => {
        if (data.is_error !== 1) {
          this.router.navigate(['login']);
          return;
        } else {
          return;
        }
      })
    }
  }

}